import { format } from 'date-fns'

import utilsService from '../../../services/UtilsService'

/** Shared REV/DL chip labels — calendar `EventKPIIndicator` + `EventKpiExplanationCallout`. KPI callout date windows use `formatSortedIsoDateStringsRange` in `helpers/date`. */

export const formatEventKpiPercentage = (value: number, prefix: string): string => {
  const body = utilsService.formatPercent(value, {
    signDisplay: 'exceptZero',
    maximumFractionDigits: 0,
  })
  return `${prefix} ${body}`
}

export const getEventKpiChipColor = (value: number): 'success' | 'warning' => {
  return value >= 0 ? 'success' : 'warning'
}

export const formatKpiRange = (start: Date, end: Date, showYear: boolean): string => {
  if (start.getTime() === end.getTime()) return format(start, showYear ? 'MMM d, yyyy' : 'MMM d')
  const sameYear = start.getFullYear() === end.getFullYear()
  const sameMonth = start.getMonth() === end.getMonth() && sameYear
  if (!sameYear) return showYear ? `${format(start, 'MMM d, yyyy')} – ${format(end, 'MMM d, yyyy')}` : `${format(start, 'MMM d')} – ${format(end, 'MMM d')}`
  if (sameMonth) return `${format(start, 'MMM d')} – ${format(end, showYear ? 'd, yyyy' : 'd')}`
  return `${format(start, 'MMM d')} – ${format(end, showYear ? 'MMM d, yyyy' : 'MMM d')}`
}
